import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";
import { APP_URLS } from "urls/AppUrls";
import FullPageLoader from "components/loaders/FullPageLoader";

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, isInitialized } = useAuth();
  if (isAuthenticated) {
    return <Navigate to={APP_URLS.HOME} />;
  }

  if (!isInitialized) {
    return <FullPageLoader />;
  }

  return <>{children}</>;
}
